/**
* @Description 文件功能说明：动态表格
* @Author 张彬
* @Time 2021/3/13 11:33
**/

/* HTML */
<template>
    <div>
<!--    表格-->
    <el-table :data="previewData"
              ref="multipleTable"
              stripe
              class="table"
              @row-click="rowClick"
              @select-all="selectAll"
              @select="selectRow"
              v-if="previewTitle.length > 0"
    >
<!--        选择框-->
        <el-table-column type="selection"
                         :selectable="checkSelectable"
                         v-if="selectBox" />

        <el-table-column label="序号" type="index" v-if="showSerialNumber" width="100px">
            <template v-slot="scope">
                <span>{{ (currentPage-1) * pageSize + scope.$index + 1}}</span>
            </template>
        </el-table-column>

<!--        列表-->
        <el-table-column  v-for="(item,index) in previewTitle"
                          :key="index"
                          :label="item.label"
                          :prop="item.prop"
                          :min-width="item.minWidth"
                          :width="item.width"

        >
            <template v-slot="scope">
                <span v-if="typeof scope.row[item.prop] == 'boolean'">
                    <el-switch
                        size="mini"
                        class="switchStyle"
                        v-model="scope.row[item.prop]"
                        :active-value="true"
                        :inactive-value="false"
                        active-color="#00A854"
                        active-text="开"
                        inactive-color="gray"
                        inactive-text="关"
                        :disabled="true"
                    />
                </span>
                <span v-else v-html="scope.row[item.prop]">
                    <span style="white-space: nowrap;" :title="scope.row[item.prop]">{{scope.row[item.prop]}}</span>
                </span>
            </template>
        </el-table-column>
<!--        操作按钮-->
        <el-table-column v-if="optionButton" label="操作">
            <template v-slot="scope">
                <span size="mini" title="编辑" class="el-icon-edit"  @click="()=>{editRow(scope.row, scope.$index)}" trigger="click" style="margin-right: 10px;" v-if="updateRow"></span>
                <span size="mini" title="删除" class="el-icon-delete"  @click="()=>{removeRow(scope.row, scope.$index)}" trigger="click" style="margin-right: 10px;" v-if="deleteRow"></span>
                <span size="mini" title="查看" class="iconfont el-icon-my_dianmingceshi"  @click="()=>{seekRow(scope.row, scope.$index)}" trigger="click" style="margin-right: 10px;" v-if="detailRow"></span>
            </template>
        </el-table-column>
    </el-table>
    </div>
</template>

/* JS */
<script>
    export default {
        /**
        * @Des 组件名
        * @Auth CC
        * @Date 2021/04/30
        */
        name: "DynamicTable",

        /**
        * @Des 接收数据
        * @Auth CC
        * @Date 2021/04/30
        */
        props:{
            /**
            * @Des 表头
            * @Auth CC
            * @Date 2021/04/30
            */
            previewTitle: {
                type: Array,
                default: function (){
                    return []
                }
            },
            /**
            * @Des 表格数据
            * @Auth CC
            * @Date 2021/04/30
            */
            previewData: {
                type: Array,
                default: function (){
                    return []
                }
            },
            /**
            * @Des 是否含有选择框
            * @Auth CC
            * @Date 2021/04/30
            */
            selectBox: {
                type: Boolean,
                default: function (){
                    return false
                }
            },

            /**
            * @Des 是否点击按钮
            * @Auth CC
            * @Date 2021/04/30
            */
            rowClickBtn: {
                type: Boolean,
                default: function (){
                    return true
                }
            },

            /**
            * @Des 最大选择数量
            * @Auth CC
            * @Date 2021/04/30
            */
            selectMaxNum: {
                type: Number,
                default: function (){
                    return -1
                }
            },
            /**
            * @Des 操作列
            * @Auth CC
            * @Date 2021/04/30
            */
            optionButton: {
                type: Boolean,
                default: function (){
                    return false
                }
            },
            /**
            * @Des 当前页
            * @Auth CC
            * @Date 2021/04/30
            */
            currentPage:{
                type: Number,
                default: function (){
                    return 1
                }
            },
            /**
            * @Des 页容量
            * @Auth CC
            * @Date 2021/04/30
            */
            pageSize:{
                type: Number,
                default: function (){
                    return 1
                }
            },

            /**
			* @Des 是否存在序号列
			* @Auth CC
			* @Date 2021/04/30
			*/
            showSerialNumber:{
                type: Boolean,
                default: function (){
                    return false
                }
            },

            /**
			* @Des 是否可编辑
			* @Auth CC
			* @Date 2021/04/30
			*/
            updateRow:{
                type: Boolean,
                default: function (){
                    return false
                }
            },

            /**
			* @Des 是否可删除
			* @Auth CC
			* @Date 2021/04/30
			*/
            deleteRow:{
                type: Boolean,
                default: function (){
                    return false
                }
            },

            /**
			* @Des 是否查看明细
			* @Auth CC
			* @Date 2021/04/30
			*/
            detailRow:{
                type: Boolean,
                default: function (){
                    return false
                }
            },
        },

        /**
			* @Des 加载完成后自动执行
			* @Auth CC
			* @Date 2021/04/30
			*/
        mounted() {
            // 存在选择框
            if(this.selectBox){
                // 延时反选
                this.$nextTick(function() {
                    for (let i = 0; i < this.previewData.length; i++) {
                        if(this.selectMaxNum < 0 || this.getSelection().length < this.selectMaxNum){
                            this.$refs.multipleTable.toggleRowSelection(this.previewData[i], this.previewData[i].checked);
                        }
                    }
                    this.$emit("selectRows", this.getSelection())
                });
            }
        },

        /**
			* @Des 方法注册
			* @Auth CC
			* @Date 2021/04/30
			*/
        methods: {

            /**
            * @Des 点击复选框
            * @Auth CC
            * @Date 2021/04/30
            */
            checkSelectable: function(row) {
                if(row.disabled){
                    return false;
                }
                return true;
            },

            /**
			* @Des 清空选择
			* @Auth CC
			* @Date 2021/04/30
			*/
            cleanSelect: function() {
                this.$refs.multipleTable.clearSelection();
            },

            /**
			* @Des 提取已选
			* @Auth CC
			* @Date 2021/04/30
			*/
            getSelection: function() {
                return this.$refs.multipleTable.selection;
            },

            /**
			* @Des 点击单元格
			* @Auth CC
			* @Date 2021/04/30
			*/
            rowClick: function (row, event, column){
                if(!row.disabled){
                    if(this.selectBox && this.rowClickBtn){
                        this.$refs.multipleTable.toggleRowSelection(row);
                    }
                    this.$emit("selectRow", row, this.getSelection())
                }
            },

            /**
			* @Des 全选
			* @Auth CC
			* @Date 2021/04/30
			*/
            selectAll: function (rows){
                this.$emit("selectRows", rows)
            },

            /**
			* @Des 单选
			* @Auth CC
			* @Date 2021/04/30
			*/
            selectRow: function (rows){
                this.$emit("selectRows", rows)
            },

            /**
			* @Des 编辑
			* @Auth CC
			* @Date 2021/04/30
			*/
            editRow: function (row, index){
                this.$emit("editRow", row, index)
            },

            /**
			* @Des 删除
			* @Auth CC
			* @Date 2021/04/30
			*/
            removeRow: function (row, index){
                this.$emit("removeRow", row, index)
            },

            /**
			* @Des 查看明细
			* @Auth CC
			* @Date 2021/04/30
			*/
            seekRow: function (row, index){
                this.$emit("seekRow", row, index)
            }
        },

    }
</script>

/* CSS */
<style lang="scss" scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/DynamicTable.vue